<ng-container *transloco="let t">
  <div class="accordion-item" [class.active]="isOpen">
    <button class="accordion-header" (click)="onToggle()">
      <span class="accordion-title">{{ t(title) }}</span>
      <span class="accordion-icon" [class.rotated]="isOpen">↗</span>
    </button>
    <div class="accordion-content" [class.expanded]="isOpen">
      <div class="accordion-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-container>
